import ErrorCodeEnum from '@/enums/error-code-enum';
import { CostBreakdown } from '@/ui/components/pages/checkout/CheckoutForm/types/CostBreakdown';
import { PricingDisplayMode } from '@/ui/components/shared/OrderPriceSummary/types/PricingDisplayMode';
import { CartItem } from '@/ui/store/cart/types';

export type WithdrawalSource = 'public' | 'myaccount';

export const WITHDRAWAL_OUTCOMES = ['cancelled', 'return_created'] as const;

export type WithdrawalOutcome = (typeof WITHDRAWAL_OUTCOMES)[number];

export type WithdrawalRequestInput = {
  orderReference: string;
  lastName: string;
  postalCode: string;
  country: string;
  captchaSolution: string;
};

export type WithdrawalRequestOutcome =
  | 'sent'
  | 'not-found'
  | 'window-exceeded'
  | 'already-withdrawn'
  | 'not-eligible'
  | 'country-not-supported'
  | 'captcha-failed'
  | 'error';

export type WithdrawalAddress = {
  firstName?: string | null;
  lastName?: string | null;
  company?: string | null;
  taxNumber?: string | null;
  street?: string | null;
  street2?: string | null;
  streetNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
};

export type WithdrawalErrorResult = {
  status: 'error';
  errorCode?: ErrorCodeEnum;
};

// Plain, serialisable data for the confirm stage. Never carries the raw order.
export type WithdrawalConfirmData =
  | {
    status: 'ok';
    reference: string;
    createdAt: string;
    costBreakdown: CostBreakdown;
    parsedProducts: CartItem[];
    pricingMode: PricingDisplayMode;
    currency?: string;
    deliveryAddress: WithdrawalAddress;
    billingAddress: WithdrawalAddress;
    email: string;
    source: WithdrawalSource;
  }
  | WithdrawalErrorResult;

// The outcome is missing only when service-api answers 2xx without a body.
export type ConfirmWithdrawalResult =
  | { status: 'ok'; outcome?: WithdrawalOutcome }
  | WithdrawalErrorResult;

export type StartMyAccountWithdrawalResult = { status: 'ok'; token: string } | { status: 'error' };
